import createImmutableSelector from 'lib/immutable/selector'
import { IHome } from './../models'

// TODO: import Store type and add reducer type in Store interface
const getHome = (state: any): IHome => state.get('homeReducer')

export const homeSelector = createImmutableSelector(getHome, (home) => home)
